import { InfoIcon } from './ds/icons';

/**
 * A finished deployment's log with no lines: they were deleted, as the build
 * logs of older deployments are. Said as a state, not as an error — nothing
 * failed, and there is nothing to retry.
 */
const LogsUnavailable = ({ fill = false }: {
  /** Takes the whole well (Overview) rather than a band of its own (a row). */
  fill?: boolean;
}) => (
  <div className={`flex flex-col items-center justify-center gap-1.5 px-6 text-center ${fill ? 'h-full py-10' : 'py-8'}`}>
    <InfoIcon size={18} className="text-navy-300" />
    <span className="text-ds-135 font-medium text-navy-100">Logs unavailable</span>
    <span className="max-w-sm text-ds-125 text-navy-300">
      The build logs of older deployments are deleted.
    </span>
  </div>
);

export default LogsUnavailable;
